var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinshifangwu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4753"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 595",
    d: "M8.1463 1.17963L1.0625 6.27294V14.8203H14.9374V6.27294L8.1463 1.17963Z",
    fill: "#D9D9D9",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 28",
    x1: 1.09326,
    y1: 8.07556,
    x2: 14.9375,
    y2: 8.07556,
    stroke: "black",
    strokeDasharray: "2 1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 29",
    d: "M6.63403 7.86948L6.63403 14.5901",
    stroke: "black",
    strokeDasharray: "2 1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinshifangwu);
export default __webpack_public_path__ + "static/media/linshifangwu.e1c6aca3e3679f2b7c8a88079db55507.svg";
export { ForwardRef as ReactComponent };